// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { MathUtils } from '@shared/utils/MathUtils';
export function validateIsEmpty(params) {
    if (!isValidNumber(params.value)) {
        return Resources.getResource('UserControl.TerceraNumeric.ValueIsEmpty');
    }
    return null;
}
export function validateMin(params) {
    const { value, min } = params;
    if (min !== undefined && value < min) {
        const formatMin = MathUtils.formatValueWithEps(min);
        const errorText = Resources.getResource('UserControl.TerceraNumeric.ValueLessMin');
        return errorText + formatMin;
    }
    return null;
}
export function validateMax(params) {
    const { value, max } = params;
    if (max !== undefined && value > max) {
        const formatMax = MathUtils.formatValueWithEps(max);
        const errorText = Resources.getResource('UserControl.TerceraNumeric.ValueGreaterMax');
        return errorText + formatMax;
    }
    return null;
}
export function validateStep(params, originalStep) {
    const { value, precision } = params;
    if (isValidNumber(originalStep) && originalStep > 0) {
        const decimalPlaces = precision !== null && precision !== void 0 ? precision : 0;
        const multiplier = Math.pow(10, decimalPlaces);
        const normalizedValue = Math.round(value * multiplier);
        const normalizedStep = Math.round(originalStep * multiplier);
        if (normalizedValue % normalizedStep !== 0) {
            const errorText = Resources.getResource('UserControl.TerceraNumeric.ValueNotMultiple');
            const formattedStep = MathUtils.formatValueWithEps(originalStep);
            return errorText + formattedStep;
        }
    }
    return null;
}
export function validateNumericValue(params) {
    const emptyError = validateIsEmpty(params);
    if (emptyError !== null) {
        return emptyError;
    }
    const minError = validateMin(params);
    if (minError !== null) {
        return minError;
    }
    const maxError = validateMax(params);
    if (maxError !== null) {
        return maxError;
    }
    return null;
}
